import { getFormattedPrice, getOldPricesList } from 'helpers'

import { IRawSubscription, ISubscription } from 'models/subscriptions.model'

import { CENTS_IN_DOLLAR } from 'root-constants/common'

export const getSubscriptionListFromRawSubscriptionList = (
  rawSubscriptionList: IRawSubscription,
): ISubscription[] =>
  rawSubscriptionList?.plans.map((rawSubscription) => ({
    id: rawSubscription.paywall.show_order.toString(),
    planId: rawSubscription.id,
    product: rawSubscription.product_key,
    paypalPlanId: rawSubscription.paypal?.plan_id,
    isDefault: rawSubscription.paywall.is_default,
    discountPercent: rawSubscription.paywall.discount_percent,
    currency: rawSubscription.pricing.currency.toLowerCase(),
    lookupKey: rawSubscription.stripe.main_lookup_key,
    trialLookupKey: rawSubscription.stripe.intro_lookup_key,
    type: rawSubscription.type,

    introDiff: {
      discountAmount: getFormattedPrice(
        rawSubscription.intro_diff?.discount_amount,
      ),
      discountPercentage: rawSubscription.intro_diff?.discount_percent,
    },

    mainPrices: {
      periodName: rawSubscription.pricing.recurring.interval,
      periodQuantity: rawSubscription.pricing.recurring.interval_count,
      fullPrice: getFormattedPrice(rawSubscription.main.current_price.amount),
      fullPriceTax: getFormattedPrice(
        rawSubscription.main.current_price.tax_amount,
      ),
      discountAmount:
        rawSubscription.main.current_price.amount_of_discount / CENTS_IN_DOLLAR,
      daily:
        rawSubscription.main.current_price.in_the_box.daily / CENTS_IN_DOLLAR,
      weekly:
        rawSubscription.main.current_price.in_the_box.weekly / CENTS_IN_DOLLAR,
      monthly:
        rawSubscription.main.current_price.in_the_box.monthly / CENTS_IN_DOLLAR,
      yearly:
        rawSubscription.main.current_price.in_the_box.yearly / CENTS_IN_DOLLAR,

      oldPrices: {
        beforeCustomDiscount:
          rawSubscription.main?.old_prices.before_custom_discount &&
          getOldPricesList(
            rawSubscription.main?.old_prices.before_custom_discount,
          ),
        before33PercentDiscount: getOldPricesList(
          rawSubscription.main?.old_prices.before_33_percent_discount,
        ),
        before50PercentDiscount: getOldPricesList(
          rawSubscription.main?.old_prices.before_50_percent_discount,
        ),
        before75PercentDiscount: getOldPricesList(
          rawSubscription.main?.old_prices.before_75_percent_discount,
        ),
      },
    },

    trialPrices: {
      fullPrice: getFormattedPrice(rawSubscription.trial?.current_price.amount),
      fullPriceTax: getFormattedPrice(
        rawSubscription.trial?.current_price.tax_amount,
      ),
      durationDays: rawSubscription.pricing.trial?.duration_days,
      daily: getFormattedPrice(
        rawSubscription.trial?.current_price.in_the_box.daily,
      ),
      weekly: getFormattedPrice(
        rawSubscription.trial?.current_price.in_the_box.weekly,
      ),
      monthly: getFormattedPrice(
        rawSubscription.trial?.current_price.in_the_box.monthly,
      ),
      yearly: getFormattedPrice(
        rawSubscription.trial?.current_price.in_the_box.yearly,
      ),

      oldPrices: {
        beforeCustomDiscount:
          rawSubscription.trial?.old_prices.before_custom_discount &&
          getOldPricesList(
            rawSubscription.trial?.old_prices.before_custom_discount,
          ),
        before33PercentDiscount: getOldPricesList(
          rawSubscription.trial?.old_prices.before_33_percent_discount,
        ),
        before50PercentDiscount: getOldPricesList(
          rawSubscription.trial?.old_prices.before_50_percent_discount,
        ),
        before75PercentDiscount: getOldPricesList(
          rawSubscription.trial?.old_prices.before_75_percent_discount,
        ),
      },
    },

    upgradeDiff: {
      amountToPay:
        (rawSubscription.upgrade_diff?.amount_to_pay || 0) / CENTS_IN_DOLLAR,
      amountPaid:
        (rawSubscription.upgrade_diff?.trial_price || 0) / CENTS_IN_DOLLAR,
      fullPrice:
        (rawSubscription.upgrade_diff?.full_price || 0) / CENTS_IN_DOLLAR,
      oldFullPrice:
        (rawSubscription.upgrade_diff?.old_full_price || 0) / CENTS_IN_DOLLAR,
    },
  }))
